import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  tabBarRow: {
    display: "flex",
    width: "100%",
    backgroundColor: "#F4F5F8",
    direction: "ltr",
  },
  tabsWrapper: {
    width: "fit-content",
    maxWidth: "100%",
    marginLeft: "auto",
    backgroundColor: theme.palette.background.paper,
  },
  tabs: {
    width: "fit-content",
    maxWidth: "100%",
    minHeight: "42px",
    flexShrink: 0,
    "& .MuiTabs-scroller": {
      overflowX: "auto !important",
      width: "fit-content !important",
      maxWidth: "100%",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    "& .MuiTabs-flexContainer": {
      width: "fit-content",
    },
    "& .MuiTab-root": {
      minHeight: "42px",
      height: "42px",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
      letterSpacing: "0.04em",
      textTransform: "none",
      color: theme.palette.text.primary,
      padding: 0,
      margin: "0 12px",
      minWidth: "unset",
      maxWidth: "none",
      flexShrink: 0,
      whiteSpace: "nowrap",
      fontFamily: theme.typography.fontFamily,
      position: "relative",
    },
    "& .Mui-selected": {
      color: `${theme.palette.primary.main} !important`,
      fontWeight: 600,
      "&::after": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: "2px",
        backgroundColor: theme.palette.primary.main,
      },
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& .MuiTabs-scrollButtons": {
      display: "none",
    },
  },
}));
